/**
 * @flow
 * @relayHash b96850b5449ecc77d6ccea4a04defad0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FormikRolesSelectQueryVariables = {|
  isDefault?: ?boolean
|};
export type FormikRolesSelectQueryResponse = {|
  +organizationRoles: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
      |}
    |}>
  |}
|};
export type FormikRolesSelectQuery = {|
  variables: FormikRolesSelectQueryVariables,
  response: FormikRolesSelectQueryResponse,
|};
*/


/*
query FormikRolesSelectQuery(
  $isDefault: Boolean
) {
  organizationRoles(isDefault: $isDefault) {
    edges {
      node {
        id
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "isDefault",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "organizationRoles",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "isDefault",
        "variableName": "isDefault"
      }
    ],
    "concreteType": "OrganizationRoleNodeConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "OrganizationRoleNodeEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "OrganizationRoleNode",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "FormikRolesSelectQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "FormikRolesSelectQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "FormikRolesSelectQuery",
    "id": null,
    "text": "query FormikRolesSelectQuery(\n  $isDefault: Boolean\n) {\n  organizationRoles(isDefault: $isDefault) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6d1a97528df0675a6242f47e5899cd20';
module.exports = node;
